import React, { useState } from 'react';
import { Button, Collapse, Form, Input, Select, Space, message } from 'antd';
import {
  previewConnectorToolRender,
  updateConnectorTool,
} from '../../services/api/agents';

export default function HttpBindingEditor({ keycloak, connectorId, tools, onSaved }) {
  const [editTool, setEditTool] = useState(null);
  const [renderConfigJson, setRenderConfigJson] = useState('');
  const [sampleJson, setSampleJson] = useState('{}');
  const [previewResult, setPreviewResult] = useState(null);
  const [saving, setSaving] = useState(false);

  return (
    <div>
      <Select
        placeholder="Select tool to edit"
        style={{ width: '100%', marginBottom: 12 }}
        value={editTool?.id}
        onChange={(id) => {
          const t = (tools || []).find((x) => x.id === id);
          setEditTool(t);
          setRenderConfigJson(JSON.stringify(t?.render_config || t?.view_binding || {}, null, 2));
          setPreviewResult(null);
        }}
        options={(tools || []).map((t) => ({ value: t.id, label: t.name }))}
      />
      {editTool ? (
        <>
          <Input.TextArea
            rows={8}
            value={renderConfigJson}
            onChange={(e) => setRenderConfigJson(e.target.value)}
            style={{ fontFamily: 'monospace', fontSize: 12 }}
          />
          <Input.TextArea
            rows={5}
            value={sampleJson}
            onChange={(e) => setSampleJson(e.target.value)}
            style={{ marginTop: 12, fontFamily: 'monospace', fontSize: 12 }}
            placeholder="Sample API response JSON"
          />
          <Space style={{ marginTop: 12 }}>
            <Button
              onClick={async () => {
                try {
                  const render_config = JSON.parse(renderConfigJson);
                  const sample_response = JSON.parse(sampleJson);
                  setPreviewResult(await previewConnectorToolRender(
                    keycloak,
                    connectorId,
                    editTool.id,
                    { render_config, sample_response },
                  ));
                } catch (e) {
                  message.error(e.message);
                }
              }}
            >
              Preview
            </Button>
            <Button
              type="primary"
              loading={saving}
              onClick={async () => {
                setSaving(true);
                try {
                  await updateConnectorTool(keycloak, connectorId, editTool.id, {
                    render_config: JSON.parse(renderConfigJson),
                  });
                  message.success('UI binding saved');
                  onSaved?.();
                } catch (e) {
                  message.error(e.message);
                } finally {
                  setSaving(false);
                }
              }}
            >
              Save
            </Button>
          </Space>
          {previewResult ? (
            <pre style={{ marginTop: 12, fontSize: 11, background: '#f5f5f5', padding: 8, borderRadius: 8 }}>
              {JSON.stringify(previewResult, null, 2)}
            </pre>
          ) : null}
        </>
      ) : null}
    </div>
  );
}
